import { getAccessRowId, type MemberAccess } from "@ext/enterprise/components/admin/settings/members/model/Member";
import { getRepositoryEditorAccesses } from "@ext/enterprise/components/admin/settings/members/model/roleRules";
import { useCallback, useState } from "react";

interface UseEditorRevokeArgs {
	accesses: MemberAccess[];
	setIsEditor: (value: boolean) => void;
	demoteAccessesToReader: (resourceIds: string[]) => void;
}

export const useEditorRevoke = ({ accesses, setIsEditor, demoteAccessesToReader }: UseEditorRevokeArgs) => {
	const [affectedAccesses, setAffectedAccesses] = useState<MemberAccess[] | null>(null);

	const requestSetIsEditor = useCallback(
		(value: boolean) => {
			const elevated = value ? [] : getRepositoryEditorAccesses(accesses);
			if (elevated.length) setAffectedAccesses(elevated);
			else setIsEditor(value);
		},
		[accesses, setIsEditor],
	);

	const confirm = useCallback(() => {
		if (!affectedAccesses) return;
		demoteAccessesToReader(affectedAccesses.map(getAccessRowId));
		setIsEditor(false);
		setAffectedAccesses(null);
	}, [affectedAccesses, demoteAccessesToReader, setIsEditor]);

	const cancel = useCallback(() => setAffectedAccesses(null), []);

	return {
		setIsEditor: requestSetIsEditor,
		dialog: {
			isOpen: affectedAccesses !== null,
			accesses: affectedAccesses ?? [],
			onConfirm: confirm,
			onCancel: cancel,
		},
	};
};
